import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

export const ChatbotContext = createContext();

const ChatbotProvider = ({ children }) => {
  const [open, setOpen] = useState(false);

  const contextValue = {
    open,
    setOpen,
  };

  return <ChatbotContext.Provider value={contextValue}>{children}</ChatbotContext.Provider>;
};

ChatbotProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ChatbotProvider;
